<template>
	<div class="refund-reason-page">
		<nio-header-nav
			position="fixed"
			:is-white="true"
			:height.sync="headerHeight"
			@back="handleBack"
		/>
		<div :style="{ marginTop: headerHeight + 'px' }">
			<template v-if="!!car">
				<div class="page-title">
					申请退款
				</div>

				<order-car-item :car="car" :showCollect="false" :order-no="orderNo" />

				<div class="form-area">
					<div class="form-title">退款原因</div>

					<order-reason :show-tips="true" @change="onChanged" />
				</div>

				<div
					class="bottom-area"
					:style="{ paddingBottom: safeAreaInsetBottom ? safeAreaInsetBottom + 'px' : '15px' }"
				>
					<nio-button :disabled="!reasonInfo" @click="confirm">确认取消</nio-button>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { supreme } from '@/supreme-core'
import { cancelOrderModel, getOrderDetail, queryVehicleDetail } from '@/model'
import { carDetailToCarItem } from '@/util/data-transfer'
import OrderCarItem from '@/components/OrderCarItem'
import OrderReason from '@/components/OrderReason'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import nativeHybrid from '@/util/nativeHybrid'

export default {
	name: 'Index',
	components: { OrderReason, OrderCarItem },
	data() {
		return {
			safeAreaInsetBottom: getSafeInsetBottom(),
			headerHeight: 0,
			car: null,
			orderNo: supreme.getQueryString('order_no'),
			reasonInfo: null
		}
	},
	created() {
		this.fetchDetail()
	},
	methods: {
		async fetchDetail() {
			try {
				const { data } = await getOrderDetail.get({}, `/${this.orderNo}/detail`)

				const orderData = data.data

				this.skuCode = orderData.commodity.commodity_code

				const carResult = await queryVehicleDetail.get({}, '/' + this.skuCode)

				if (!carResult.data || carResult.data.result_code !== 'success') {
					throw new Error()
				}

				this.car = carDetailToCarItem(carResult.data.data)
			} catch (e) {
				// this.$router.push({ path: "/error", query: {message: '网络请求失败'}});
			}
		},

		handleBack() {
			nativeHybrid.closeSyn()
		},
		onChanged(info) {
			this.reasonInfo = info
		},
		confirm() {
			if (!this.reasonInfo) {
				return
			}
			const params = {
				cancel_reason_type: this.reasonInfo.code,
				cancel_reason_desc: this.reasonInfo.code === 7 ? this.reasonInfo.customReason : ''
			}

			cancelOrderModel
				.post({
					order_no: this.orderNo,
					...params
				})
				.then(() => {
					nativeHybrid.closeSyn()
				})
				.catch(e => {
					this.$toast('请求失败')
				})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@nio-fe/nio-app-ui/es/style/index';
.refund-reason-page {
	padding: 0 20px;

	.page-title {
		@include headline_1(1.4, 400, false);
		color: $text_primary;
		margin: 20px 0 30px;
	}

	.form-area {
		margin-top: 60px;
		padding-bottom: 140px;

		.form-title {
			@include subtitle_2(1.4, 500, false);
			color: $text_primary;
			margin-bottom: 10px;
		}
	}

	.bottom-area {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		background: #ffffff;
		padding: 20px 20px 0;
	}
}
</style>
